import { render, staticRenderFns } from "./crm-search.vue?vue&type=template&id=2945053c"
import script from "./crm-search.vue?vue&type=script&lang=js"
export * from "./crm-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports